import ErrorPageController from './ErrorPageController';

export default ErrorPageController;
